import { ColumnState } from 'ag-grid-community';
import { DateRange } from 'react-day-picker';
import { create } from 'zustand';
import { defaultMST3020_R01DetailDto, defaultMST3020_R01HeaderDto, MST3020_R01DetailDto, MST3020_R01HeaderDto } from './Dto_MST3020_R01';
import { showWarning } from 'src/utils/toast/toastUtil';


export interface MST3020_R01Filter {
	brandCd: string;
	itemGroup: string;
	itemAccount: string;
}
export interface Store_MST3020_R01 {
	MST3020_R01Filter: MST3020_R01Filter;
	MST3020_R01PastFilter: MST3020_R01Filter;
	setMST3020_R01Filter: (filter: Partial<Store_MST3020_R01['MST3020_R01Filter']>) => void;
	setMST3020_R01PastFilter: (filter: Store_MST3020_R01['MST3020_R01PastFilter']) => void;
	
	// ====== 매출 리스트 및 선택/편집 ======
	MST3020_R01List: MST3020_R01HeaderDto[];
	setMST3020_R01List: (dataList: MST3020_R01HeaderDto[]) => void;

	editMST3020_R01: MST3020_R01HeaderDto | null;
	setEditMST3020_R01: (editSale: MST3020_R01HeaderDto | null) => void;

	selectedMST3020_R01: MST3020_R01HeaderDto | undefined;
	setSelectedMST3020_R01: (data: MST3020_R01HeaderDto | undefined) => void;
	initSelectedMST3020_R01: () => void;

	// ====== 상세(디테일) 행 선택/삭제 관리 ======
	deletedMST3020_R01DetailList: string[];
	setDeletedMST3020_R01DetailList: (idList: string[]) => void;
	addDeletedMST3020_R01DetailList: (idList: string[]) => void;
	removeDeletedMST3020_R01DetailList: (idList?: string[]) => void;

	// ====== 매출 상세(디테일) 데이터 ======
	MST3020_R01DetailList: MST3020_R01DetailDto[];
	setMST3020_R01DetailList: (data: MST3020_R01DetailDto[]) => void;
	insertMST3020_R01DetailList: (data: MST3020_R01DetailDto[], index?: number) => void;
	removeMST3020_R01DetailList: (index: number) => void;
	updateMST3020_R01DetailList: (index: number, data: MST3020_R01DetailDto) => void;

	// ====== 선택(디테일) 행 선택/삭제 관리 ======
	selectedMST3020_R01DetailList: string[];
	setSelectedMST3020_R01DetailList: (idList: string[]) => void;
	addSelectedMST3020_R01DetailList: (idList: string[]) => void;
	removeSelectedMST3020_R01DetailList: (idList?: string[]) => void;
	initSelectedMST3020_R01DetailList: () => void;

	editMST3020_R01Detail: MST3020_R01DetailDto | null;
	setEditMST3020_R01Detail: (editDetail: MST3020_R01DetailDto | null) => void;

	originalMST3020_R01DetailList: MST3020_R01DetailDto[];
	setOriginalMST3020_R01DetailList: (data: MST3020_R01DetailDto[]) => void;

	// ====== 컬럼 상태(그리드) ======
	columnState: ColumnState[] | null;
	setColumnState: (state: ColumnState[] | null) => void;
	detailColumnState: ColumnState[] | null;
	setDetailColumnState: (state: ColumnState[] | null) => void;

	scrollTop: number | null;
	setScrollTop: (top: number | null) => void;
	detailScrollTop: number | null;
	setDetailScrollTop: (top: number | null) => void;

	allCount: number;				setAllCount: (allCount: number) => void;
	detailFetchTrigger: boolean;
	setDetailFetchTrigger: (trigger: boolean) => void;

	// ====== 초기화 ======
	initData: () => void;

}

export const defaultMST3020_R01Filter : MST3020_R01Filter = {
	brandCd: '',
	itemGroup: '',
	itemAccount: ''
};

export const useMST3020_R01Store = create<Store_MST3020_R01>((set) => ({
	MST3020_R01Filter: defaultMST3020_R01Filter,
	MST3020_R01PastFilter: defaultMST3020_R01Filter,
	setMST3020_R01Filter: (update) => set((state) => ({
		MST3020_R01Filter: {
			...state.MST3020_R01Filter,
			...update
		}
	})),
	setMST3020_R01PastFilter: (filter: Store_MST3020_R01['MST3020_R01PastFilter']) => set((state) => {
		return {
			...state,
			MST3020_R01PastFilter: filter
		}
	}),

	// ====== 매출 리스트 및 선택/편집 ======
	MST3020_R01List: [],
	setMST3020_R01List: (dataList: MST3020_R01HeaderDto[]) => set((state) => {
		return {
			...state,
			MST3020_R01List: dataList
		}
	}),

	editMST3020_R01: defaultMST3020_R01HeaderDto,
	setEditMST3020_R01: (editSale: MST3020_R01HeaderDto | null) => set((state) => {
		return {
			...state,
			editMST3020_R01: editSale
		}
	}),

	selectedMST3020_R01: undefined,
	
	setSelectedMST3020_R01: (data: MST3020_R01HeaderDto | undefined) => set((state) => {

		return { 
			...state,
			selectedMST3020_R01: data,
			selectedMST3020_R01DetailList: [],
			deletedMST3020_R01DetailList: [],
			detailFetchTrigger: true,
		};
	}),
	initSelectedMST3020_R01: () => set({
		selectedMST3020_R01: undefined,
		editMST3020_R01: defaultMST3020_R01HeaderDto,
		editMST3020_R01Detail: defaultMST3020_R01DetailDto,
		MST3020_R01DetailList: [],
		detailFetchTrigger: false,
	}),

	// ====== 매출 상세(디테일) 데이터 ======
	MST3020_R01DetailList: [],
	setMST3020_R01DetailList: (data: MST3020_R01DetailDto[]) => set((state) => {
		let newList: MST3020_R01DetailDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item, index) => {
			// console.log(index + '번째 행의 item.Index 정보: ' 
			// 	+ ' valueIndex : ' + item.valueIndex 
			// 	+ ' valueAndOrderIndex : ' + valueAndOrderIndex
			// 	+ ' orderIndex : ' + item.orderIndex 
			// 	+ ' orderIndexSeq : ' + item.orderIndexSeq);
			newList.push({ 
				//...defaultMST3020_R01DetailDto,
				...item,
				valueIndex: item.valueIndex > 0 ? item.valueIndex : valueAndOrderIndex,
				orderIndex: item.orderIndex > -1 ? item.orderIndex : valueAndOrderIndex,
				orderIndexSeq: item.orderIndexSeq > 0 ? item.orderIndexSeq : 0
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			MST3020_R01DetailList: newList
		}
	}),
	insertMST3020_R01DetailList: (data: MST3020_R01DetailDto[], index?: number) => set((state) => {
		let newMST3020_R01DetailList = [...state.MST3020_R01DetailList];

		let targetRowData = newMST3020_R01DetailList.find(item => item.valueIndex === index);
		let targetOrderIndex = targetRowData?.orderIndex || 0;
		// 데이터에 orderIndex가 있으면 그것을 사용하고, 없으면 1 (index 파라미터는 배열 위치로만 사용)		

		const newOrderIndexSeq = (targetRowData?.orderIndexSeq || 0) + 1;
		// console.log('targetOrderIndex : ', targetOrderIndex);
		// console.log('newOrderIndexSeq : ', newOrderIndexSeq);
		let maxValueIndex = Math.max(0, ...newMST3020_R01DetailList.map(item => item.valueIndex || 0)) + 1;

		// newMST3020_R01DetailList에서 targetOrderIndex인 행들을 빼내서 newOrderIndexSeq 기준으로 다시 정렬
		// newOrderIndexSeq 보다 orderIndexSeq가 작은 행들은 유지. 
		// newOrderIndexSeq 보다 orderIndexSeq가 큰 행들은 기존 orderIndexSeq 값에 1을 더해서 저장.
		const targetRows = newMST3020_R01DetailList.filter(item => item.orderIndex === targetOrderIndex);
		targetRows.forEach(item => {
			if(item.orderIndexSeq < newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq;
			} else if(item.orderIndexSeq >= newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq + 1;
			}
		});

		// targetRows를 newMST3020_R01DetailList에 대체
		newMST3020_R01DetailList = newMST3020_R01DetailList.filter(item => item.orderIndex !== targetOrderIndex);
		newMST3020_R01DetailList.push(...targetRows);
		
		//새 행을 생성해서 newOrderIndexSeq 값의 행을 저장
		const newData = data.map(item => ({ ...defaultMST3020_R01DetailDto, ...item, 
			valueIndex: maxValueIndex++,
			orderIndex: targetOrderIndex,
			orderIndexSeq: newOrderIndexSeq
		}));
		if (index !== undefined) {
			newMST3020_R01DetailList.splice(index, 0, ...newData);
		} else {
			newMST3020_R01DetailList.push(...newData);
		}
		
		return {
			...state,
			MST3020_R01DetailList: newMST3020_R01DetailList
		}
	}),
	removeMST3020_R01DetailList: (index: number) => set((state) => {
		const newMST3020_R01DetailList = [...state.MST3020_R01DetailList].filter((item) => item.valueIndex !== index);
		return {
			...state,
			MST3020_R01DetailList: newMST3020_R01DetailList
		}
	}),
	updateMST3020_R01DetailList: (valueIndex: number, data: MST3020_R01DetailDto) => set((state) => {
		const _MST3020_R01DetailList = state.MST3020_R01DetailList.map(item =>
			item.valueIndex === valueIndex ? data : item
		);
		if(data.cycletime < 0) {
			showWarning('CycleTime는 0보다 작을 수 없습니다.');
			data.cycletime = 0;
		}
		if(data.cavity < 0) {
			showWarning('캐비티는 0보다 작을 수 없습니다.');
			data.cavity = 0;
		}
		if(data.boxQty < 0) {
			showWarning('박스량은 0보다 작을 수 없습니다.');
			data.boxQty = 0;
		}
		return {
			...state,
			MST3020_R01DetailList: _MST3020_R01DetailList
		}
	}),
	
	// ====== 상세(디테일) 행 선택/삭제 관리 ======
	deletedMST3020_R01DetailList: [],
	setDeletedMST3020_R01DetailList: (idList: string[]) => set((state) => {
		return {
			...state,
			deletedMST3020_R01DetailList: idList
		}
	}),
	addDeletedMST3020_R01DetailList: (idList: string[]) => set((state) => {
		const _deletedDetailList = [...state.deletedMST3020_R01DetailList];

		for(const valueIndex of idList) {
			const isInserted = state.MST3020_R01DetailList.find(item => item.valueIndex === Number(valueIndex) && item.inserted);
			const isModified = state.MST3020_R01DetailList.find(item => item.valueIndex === Number(valueIndex) && item.isModified);
			if(!isInserted && !isModified) {
				_deletedDetailList.push(valueIndex);
			}
		}
		
		return {
			...state,
			deletedMST3020_R01DetailList: _deletedDetailList
		}
	}),
	removeDeletedMST3020_R01DetailList: (idList?: string[]) => set((state) => ({
		...state,
		deletedMST3020_R01DetailList: [...state.deletedMST3020_R01DetailList].filter(value => idList ? !idList.includes(value) : false)
	})),

	selectedMST3020_R01DetailList: [],
	setSelectedMST3020_R01DetailList: (idList: string[]) => set((state) => {

		//맨 마지막으로 선택한 행을 editMST3020_R01Detail로 설정
		const lastRow = state.MST3020_R01DetailList[state.MST3020_R01DetailList.length - 1];

		return {
			...state,
			selectedMST3020_R01DetailList: idList,
			editMST3020_R01Detail: lastRow
		}
	}),
	addSelectedMST3020_R01DetailList: (idList: string[]) => set((state) => {
		const _selectedMST3020_R01DetailList = [...state.selectedMST3020_R01DetailList];
		if(idList.length > 0) {
			_selectedMST3020_R01DetailList.push(...idList);
		}
		return {
			...state,
			selectedMST3020_R01DetailList: _selectedMST3020_R01DetailList
		}
	}),
	removeSelectedMST3020_R01DetailList: (idList?: string[]) => set((state) => ({
		...state,
		selectedMST3020_R01DetailList: [...state.selectedMST3020_R01DetailList].filter(value => idList ? !idList.includes(value) : false)
	})),
	initSelectedMST3020_R01DetailList: () => set({ selectedMST3020_R01DetailList: [], editMST3020_R01Detail: defaultMST3020_R01DetailDto }),

	editMST3020_R01Detail: defaultMST3020_R01DetailDto,
	setEditMST3020_R01Detail: (editDetail: MST3020_R01DetailDto | null) => set((state) => {

		let newDetailList = state.MST3020_R01DetailList;

		// editDetail이 존재하고, valueIndex가 유효한 경우에만 detailList를 업데이트합니다.
		if (editDetail && editDetail.valueIndex) {
			newDetailList = state.MST3020_R01DetailList.map(item =>
				item.valueIndex === editDetail.valueIndex
					? { 
						...item,
						standardSheet: editDetail.standardSheet,
						standardSheet2: editDetail.standardSheet2,
						isModified: editDetail.standardSheet !== item.standardSheet || editDetail.standardSheet2 !== item.standardSheet2
					} // 기존 item 데이터에 변경된 editDetail 데이터를 덮어씁니다.
					: item
			);
		}

		return {
			...state,
			MST3020_R01DetailList: newDetailList, // 업데이트된 새 배열로 상태를 교체합니다.
			editMST3020_R01Detail: editDetail
		}
	}),

	originalMST3020_R01DetailList: [],
	setOriginalMST3020_R01DetailList: (data: MST3020_R01DetailDto[]) => set((state) => {
		let newList: MST3020_R01DetailDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item, index) => {
			newList.push({ 
				...defaultMST3020_R01DetailDto,
				...item,
				valueIndex: valueAndOrderIndex,
				orderIndex: valueAndOrderIndex,
				orderIndexSeq: valueAndOrderIndex
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			originalMST3020_R01DetailList: newList
		}
	}),

	// ====== 컬럼 상태(그리드) ======
	columnState: null,				setColumnState: (state: ColumnState[] | null) => set({ columnState: state }),
	detailColumnState: null,		setDetailColumnState: (state: ColumnState[] | null) => set({ detailColumnState: state }),

	scrollTop: null,
	setScrollTop: (top: number | null) => set({ scrollTop: top }),
	detailScrollTop: null,
	setDetailScrollTop: (top: number | null) => set({ detailScrollTop: top }),

	allCount: 0,					setAllCount: (allCount: number) => set({ allCount }),
	detailFetchTrigger: false,
	setDetailFetchTrigger: (trigger: boolean) => set({ detailFetchTrigger: trigger }),

	// ====== 초기화 ======
	initData: () => set((state) => ({
		...state,
		MST3020_R01Filter: defaultMST3020_R01Filter,
		MST3020_R01PastFilter: defaultMST3020_R01Filter,
		MST3020_R01List: [],
		selectedMST3020_R01: undefined,
		MST3020_R01DetailList: [],
		deletedMST3020_R01DetailList: [],
		selectedMST3020_R01DetailList: [],
		editMST3020_R01: defaultMST3020_R01HeaderDto,
		editMST3020_R01Detail: defaultMST3020_R01DetailDto,
		allCount: 0,
		detailFetchTrigger: false,
		scrollTop: null,
		detailScrollTop: null,
		
	})),

}));
